import { JSX } from 'react';
import { SkeletonPulse } from './SkeletonPulse';
import classes from './BettingOptionsSkeleton.module.scss';

interface IProps {
    bettingOptionsCount?: number;
}

export const BettingOptionsSkeleton = ({ bettingOptionsCount = 4 }: IProps): JSX.Element => (
    <div className={classes.container}>
        <div className={classes.tabs}>
            {Array(6)
                .fill(null)
                .map((_, index) => (
                    <SkeletonPulse
                        key={index}
                        width="950px"
                        radius="5px"
                        height="24px"
                        className={classes.tab}
                    />
                ))}
        </div>
        {Array(bettingOptionsCount)
            .fill(null)
            .map((_, index) => (
                <div key={index} className={classes.bettingOption}>
                    <div className={classes.name}>
                        <SkeletonPulse
                            height="15px"
                            width="15px"
                            radius="50%"
                            className={classes.favorites}
                        />
                        <SkeletonPulse height="19px" width="50%" radius="5px" />
                    </div>
                    <SkeletonPulse height="15px" width="35px" radius="5px" />
                </div>
            ))}
    </div>
);
